module.exports = __webpack_public_path__ + "img/mail.2b36890d.svg";